


interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string,
        type?: string,
        title?: string,
        description?: string,
        url?: string,
        site_name?: string,
        updated_time?: string,
        image?: string,
        image_secure_url?: string,
        image_width?: number,
        image_height?: number,
        image_alt?: string,
        image_type?: string,
        video?: string,
        video_duration?: number,
        video_upload_date?: string,
        video_allow_embed?: boolean,
    };
    twitter?: {
        card?: string,
        title?: string,
        description?: string,
        image?: string,
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface ingredients {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    // ingredients: ingredients;
    // treatmentAreas1: TreatmentArea[];
    // treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string,
        beforeAfter: string[] | any,
        introductionImage?: string,
    };
    product: {
        id: number,
        title: string,
        price: number,
        description: string,
    };
}

export const cardiosupport: {
    en: LanguageContent,
    ar: LanguageContent,
    shared: SharedData,
} =
{
    "en": {
        "url": "cardio-support-iv-drip",
        "meta": {
            "title": "Cardio Support IV Drip in Dubai | Elite Body Home",
            "description": "Specialized IV therapy to support heart health, promote cardiovascular function, and boost overall vitality with direct nutrient infusion.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/cardio-support-iv-drip/",
            "og": {
                "title": "Cardio Support IV Drip in Dubai | Elite Body Home",
                "description": "IV therapy to support heart health and cardiovascular function",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-50.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Cardio Support IV Drip"],
        "hero": {
            "title": "Cardio Support IV Drip in Dubai",
            "subtitle": "Heart Health Enhancement Therapy",
            "description": "The Cardio Support IV Drip is a unique IV designed to support your heart health. The intravenous drip provides a synergistic blend of vitamins, minerals, and antioxidants, which enters the bloodstream immediately, promoting heart function, minimizing inflammation, and boosting overall vitality. Great for those with heart conditions or looking to maximise their heart health, the Cardiac Support IV Drip has rapid and effective results."
        },
        "howItWorks": {
            "title": "How Does Cardio Support IV Drip Work?",
            "description": "The procedure for the Cardiac Support IV Drip is a straightforward, quick, and non-invasive process, ensuring a hassle-free experience for patients with little to no discomfort. This practice consists of introducing vital micronutrients through one of your veins to the blood so that they can get absorbed way faster than you would take on if you ingested food."
        },
        "procedureSteps": {
            "heading": "Procedure Overview",
            "para": "Here's what to expect during your Cardio Support IV Drip session:",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "A health-care provider reviews your medical history and heart health to see if you're a good fit for the therapy.",
                    "icon": "fa-solid fa-clipboard-question"
                },
                {
                    "title": "Preparation",
                    "desc": "Infusions can help mitigate vascular inflammation by administrating IV Drip loaded with nutrients that support heart health—vitamins, minerals, and antioxidants.",
                    "icon": "fa-solid fa-flask"
                },
                {
                    "title": "IV Insertion",
                    "desc": "A trained professional inserts a sterile needle into a vein, usually in the arm, to deliver the infusion.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "Infusion Process",
                    "desc": "The IV infusion is completed in about 30–60 minutes, enabling a direct absorption of nutrients into the bloodstream for the greatest support of the heart.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "Post-Treatment",
                    "desc": "After the IV is complete, they will pull the needle, and you might rest for a moment. Most patients leave feeling rejuvenated.",
                    "icon": "fa-solid fa-check-circle"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits of Cardio Support IV Drip",
            "subheading": "Experience improved cardiovascular function and heart health",
            "para": "The IV Drip has many advantages for those seeking to improve their heart health or manage existing cardiovascular issues. This combination of antioxidants and nutrients is designed to support cardiovascular function and promote general health.",
            "items": [
                {
                    "title": "Improved heart function",
                    "desc": "Supports proper function of the heart muscles and blood vessels.",
                    "icon": "fa-solid fa-heartbeat"
                },
                {
                    "title": "Enhanced energy levels",
                    "desc": "Lowers tiredness and increases energy levels by enhancing flow and oxygen transport.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "Reduced inflammation",
                    "desc": "In the drip, antioxidants that help fight inflammation, a major cause of heart disease.",
                    "icon": "fa-solid fa-shield-alt"
                },
                {
                    "title": "Boosts immune system",
                    "desc": "Boosts immune health, which in turn supports heart health.",
                    "icon": "fa-solid fa-shield-virus"
                },
                {
                    "title": "Better circulation",
                    "desc": "Enhances blood circulation and minimizes the potential of thrombosis formation.",
                    "icon": "fa-solid fa-heart-pulse"
                },
                {
                    "title": "Fast absorption",
                    "desc": "IV therapy infuses nutrients (instead of swallowing pills) directly into the bloodstream for faster results than any oral supplement.",
                    "icon": "fa-solid fa-tachometer-alt"
                }
            ]
        },
        "eligibility": {
            "heading": "Who Can Benefit from Cardio Support IV Drip?",
            "subheading": "",
            "para": "Great for someone looking to maintain or improve their heart health or someone managing specific cardiovascular conditions. Some individuals might receive a greater advantage from this treatment.",
            "items": [
                {
                    "title": "People with a family history of heart disease",
                    "desc": "",
                    "icon": "fa-solid fa-family"
                },
                {
                    "title": "People who have chronic fatigue or lower levels of energy",
                    "desc": "",
                    "icon": "fa-solid fa-tired"
                },
                {
                    "title": "Patient recovered from cardiothoracic surgeries",
                    "desc": "",
                    "icon": "fa-solid fa-procedures"
                },
                {
                    "title": "Those who have high cardiovascular demands of athletes",
                    "desc": "",
                    "icon": "fa-solid fa-running"
                },
                {
                    "title": "People with risk factors for heart disease",
                    "desc": "Like high cholesterol or hypertension.",
                    "icon": "fa-solid fa-heart-crack"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation Before Your Treatment",
            "subheading": "",
            "para": "Preparation for your Cardio Support IV Drip treatment will help ensure the optimal outcome. Right before the session, it would be best to prepare both your body and the doing to your body so is fully prepared to receive the nutrients and allow the session to run smoothly.",
            "items": [
                {
                    "title": "Consultation",
                    "desc": "Schedule an initial consultation to evaluate your cardiovascular health and review any pre-existing medical issues.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "Hydration",
                    "desc": "Make sure to stay hydrated by drinking water before your session.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Avoid caffeine and alcohol",
                    "desc": "These substances can inhibit nutrient absorption or lead to dehydration.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "Medication review",
                    "desc": "Let your provider know about any medications or supplements you're taking so you don't have a possible interaction.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "Comfortable clothing",
                    "desc": "Wear lose clothes so that your arms or hands are easily available for the IV insertions.",
                    "icon": "fa-solid fa-tshirt"
                }
            ]
        },
        "results": {
            "heading": "Expected Results",
            "subheading": "",
            "para": "Many of our patients report better energy levels, mental clarity, and enhanced cardiovascular function all within the first few sessions of Cardiac Support IV Drip therapy. Long-term benefits include:",
            "items": [
                {
                    "title": "More endurance, less exhaustion",
                    "desc": "",
                    "icon": "fa-solid fa-battery-full"
                },
                {
                    "title": "Better blood flow and circulation",
                    "desc": "",
                    "icon": "fa-solid fa-heart-pulse"
                },
                {
                    "title": "Reduced risk of cardiovascular events",
                    "desc": "",
                    "icon": "fa-solid fa-heart-circle-check"
                },
                {
                    "title": "Improved immune system function",
                    "desc": "",
                    "icon": "fa-solid fa-shield-virus"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Aftercare Recommendations",
            "subheading": "",
            "para": "You do NOT need to do anything different or resume normal activities immediately. The best practice is to stay hydrated and pay attention to any reactions, although side effects are not common.",
            "items": [
                {
                    "title": "Hydration",
                    "desc": "Continue drinking plenty of water after your treatment.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Monitor your body",
                    "desc": "Pay attention to how your body responds to the treatment.",
                    "icon": "fa-solid fa-heartbeat"
                },
                {
                    "title": "Follow-up sessions",
                    "desc": "Consider regular treatments for sustained cardiovascular support.",
                    "icon": "fa-solid fa-calendar-alt"
                },
                {
                    "title": "Healthy lifestyle",
                    "desc": "Maintain heart-healthy habits to complement the treatment effects.",
                    "icon": "fa-solid fa-heart"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "How long does a Cardio Support IV Drip session take?",
                    "answer": "The IV infusion is completed in about 30–60 minutes."
                },
                {
                    "question": "Is the treatment painful?",
                    "answer": "Patients may feel a small pinch during needle insertion, but the treatment itself is painless."
                },
                {
                    "question": "How soon will I notice results?",
                    "answer": "Many patients report feeling better energy levels and improved cardiovascular function within the first few sessions."
                },
                {
                    "question": "How often should I get this treatment?",
                    "answer": "Frequency depends on individual needs - our medical professionals can recommend a schedule during consultation."
                },
                {
                    "question": "Are there any side effects?",
                    "answer": "Side effects are rare but may include minor bruising at the injection site."
                }
            ]
        }
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/New-Servicesef-Bsfeanner-Image-3-scaled.jpg",
            "beforeAfter": []
        },
        "product": {
            "id": 8,
            "title": "Cardio Support IV Drip in Dubai",
            "description": "Specialized IV therapy to support heart health and cardiovascular function with direct nutrient infusion.",
            "price": 699
        }
    },
    "ar": {
        "url": "cardio-support-iv-drip",
        "meta": {
            "title": "دعم القلب بالتنقيط الوريدي في دبي | ايليت بودي هوم",
            "description": "علاج متخصص لدعم صحة القلب وتعزيز وظائفه من خلال تركيبة مغذية تعطى مباشرة في الوريد لتحسين الدورة الدموية والصحة العامة.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/cardio-support-iv-drip",
            "og": {
                "title": "دعم القلب بالتنقيط الوريدي في دبي | ايليت بودي هوم",
                "description": "علاج وريدي لدعم صحة القلب وتحسين وظائفه",
                "image": "https://www.elitebodyhome.com/images/cardio-support-iv-og.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "دعم القلب بالتنقيط الوريدي"],
        "hero": {
            "title": "دعم القلب بالتنقيط الوريدي",
            "subtitle": "علاج تعزيز صحة القلب",
            "description": "يُعد علاج التنقيط الوريدي لدعم القلب علاج مميز صُمم خصيصًا لتعزيز صحة القلب. يوفر هذا العلاج مزيجًا متكاملاً من الفيتامينات والمعادن ومضادات الأكسدة، يُحقن مباشرةً في مجرى الدم، مما يساعد على دعم وظائف القلب، وتقليل الالتهابات، وتعزيز الدورة الدموية وصحة القلب والصحة العامة للجسم. تُعد هذه الجلسة خيارًا مثاليًا لمن يعانون من حالات قلبية، أو لأولئك الذين يسعون إلى تعزيز صحة القلب بشكل وقائي، حيث تمنح نتائج سريعة وفعالة."
        },
        "howItWorks": {
            "title": "كيف يعمل علاج دعم القلب بالتنقيط الوريدي؟",
            "description": "تعتبر جلسة دعم القلب بالتنقيط الوريدي هي إجراء بسيط وسريع وغير جراحي، يضمن للمريض تجربة مريحة بأقل قدر من الألم أو بدونه. تعتمد هذه الطريقة على إدخال العناصر الغذائية الدقيقة الأساسية مباشرةً إلى مجرى الدم عبر أحد الأوردة، مما يضمن امتصاصها بشكل أسرع لدعم توازن سكر الدم والصحة العامة."
        },
        "procedureSteps": {
            "heading": "خطوات الإجراء",
            "para": "إليك ما يمكن توقعه خلال جلسة العلاج:",
            "steps": [
                {
                    "title": "استشارة الطبيب",
                    "desc": "يبدأ الإجراء بجلسة استشارية مع الطبيب الذي يراجع تاريخك الطبي وصحة القلب لتحديد مدى ملاءمتك للعلاج.",
                    "icon": "fa-solid fa-clipboard-question"
                },
                {
                    "title": "التحضير",
                    "desc": "يتم تجهيز محلول التنقيط الوريدي بفيتامينات ومعادن ومضادات أكسدة تدعم صحة القلب وتساعد في تقليل التهابات الأوعية الدموية.",
                    "icon": "fa-solid fa-flask"
                },
                {
                    "title": "إدخال الإبرة الوريدية",
                    "desc": "يقوم متخصص مدرب بإدخال إبرة معقمة في وريد الذراع عادةً، لحقن المحلول.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "الحقن",
                    "desc": "تستغرق جلسة الحقن الوريدي من 30 إلى 60 دقيقة تقريبًا، مما يسمح بامتصاص مباشر للعناصر الغذائية في مجرى الدم للحصول على أقصى دعم للقلب.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "ما بعد العلاج",
                    "desc": "بمجرد انتهاء الجلسة، تُزال الإبرة ويمكنك الاستراحة لعدة دقائق. يشعر معظم المرضى بالانتعاش بعد الجلسة.",
                    "icon": "fa-solid fa-check-circle"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد علاج التنقيط الوريدي لدعم القلب",
            "subheading": "استمتع بتحسين صحة القلب ووظائفه",
            "para": "يوفر العلاج العديد من الفوائد للأشخاص الذين يسعون لتعزيز صحة القلب أو التعامل مع مشكلات القلب والأوعية الدموية. يُصمم العلاج بمزيج من مضادات الأكسدة والعناصر الغذائية لدعم وظائف القلب وتعزيز الصحة العامة.",
            "items": [
                {
                    "title": "تحسين وظائف القلب",
                    "desc": "يدعم الأداء السليم لعضلة القلب والأوعية الدموية.",
                    "icon": "fa-solid fa-heartbeat"
                },
                {
                    "title": "تعزيز مستويات الطاقة",
                    "desc": "يُقلل من الشعور بالإرهاق ويعزز مستويات الطاقة من خلال تحسين تدفق الدم ونقل الأوكسجين في الجسم.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "تقليل الالتهابات",
                    "desc": "يحتوي المحلول على مضادات أكسدة تساهم في مقاومة الالتهاب، الذي يُعد من الأسباب الرئيسية لأمراض القلب.",
                    "icon": "fa-solid fa-shield-alt"
                },
                {
                    "title": "تعزيز الجهاز المناعي",
                    "desc": "يدعم العلاج الصحة المناعية، مما ينعكس بشكل إيجابي على صحة القلب.",
                    "icon": "fa-solid fa-shield-virus"
                },
                {
                    "title": "تنشيط الدورة الدموية",
                    "desc": "يُساهم في تحسين تدفق الدم وتقليل احتمالية تكون الجلطات.",
                    "icon": "fa-solid fa-heart-pulse"
                },
                {
                    "title": "يحقق امتصاص سريع للعناصر الغذائية",
                    "desc": "تُحقن العناصر الغذائية مباشرةً إلى مجرى الدم، مما يضمن نتائج أسرع مقارنة بالمكملات الغذائية التي تؤخذ عن طريق الفم.",
                    "icon": "fa-solid fa-tachometer-alt"
                }
            ]
        },
        "eligibility": {
            "heading": "الأهلية للعلاج",
            "subheading": "",
            "para": "يُعد هذا العلاج خيارًا مثاليًا لمن يسعون إلى الحفاظ على صحة القلب أو تحسينها، وكذلك لمن يعانون من أمراض قلبية معينة ويحتاجون إلى دعم إضافي. وقد يستفيد بعض الأفراد من هذا العلاج بدرجة أكبر، مثل:",
            "items": [
                {
                    "title": "الأشخاص الذين لديهم تاريخ عائلي من أمراض القلب",
                    "desc": "",
                    "icon": "fa-solid fa-family"
                },
                {
                    "title": "الأشخاص الذين يعانون من الإرهاق المزمن أو انخفاض مستويات الطاقة",
                    "desc": "",
                    "icon": "fa-solid fa-tired"
                },
                {
                    "title": "المرضى الذين تعافوا من الجراحات القلبية الصدرية",
                    "desc": "",
                    "icon": "fa-solid fa-procedures"
                },
                {
                    "title": "الرياضيون أو من يخضعون لمجهود بدني مكثف يؤثر على القلب",
                    "desc": "",
                    "icon": "fa-solid fa-running"
                },
                {
                    "title": "الأشخاص المعرضون لخطر ارتفاع الكوليسترول أو ارتفاع ضغط الدم",
                    "desc": "",
                    "icon": "fa-solid fa-heart-crack"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد قبل الجلسة",
            "subheading": "",
            "para": "يُساهم التحضير المسبق لجلسة التنقيط الوريدي لدعم القلب في الحصول على نتائج مثالية. يُنصح بالاستعداد الجسدي والنفسي قبل الجلسة لضمان استجابة الجسم بشكل فعال للعناصر الغذائية، وضمان سلاسة الجلسة.",
            "items": [
                {
                    "title": "استشارة الطبيب",
                    "desc": "احجز استشارة أولية لتقييم صحة القلب ومراجعة أي حالات طبية سابقة.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "الترطيب المستمر",
                    "desc": "اشرب كمية كافية من الماء قبل الجلسة، حيث يُساعد ترطيب الجسم على تسهيل إدخال الإبرة وتحسين امتصاص العناصر.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "تجنب الكافيين والكحول",
                    "desc": "امتنع عن الكافيين أو المشروبات الكحولية، لأنها قد تُعيق امتصاص العناصر أو تُسبب الجفاف.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "مراجعة الأدوية",
                    "desc": "أبلغ الطبيب بأي أدوية أو مكملات غذائية تتناولها، لتجنب حدوث أي تداخلات محتملة.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "ارتداء ملابس مريحة",
                    "desc": "اختر ملابس فضفاضة تُسهّل الوصول إلى الذراعين أو اليدين من أجل إدخال إبرة الوريد بسهولة.",
                    "icon": "fa-solid fa-tshirt"
                }
            ]
        },
        "results": {
            "heading": "النتائج المتوقعة",
            "subheading": "",
            "para": "يلاحظ العديد من مرضانا تحسن ملحوظ في مستويات الطاقة ووظائف قلب، وصفاء ذهني أفضل خلال الجلسات الأولى من علاج التنقيط الوريدي لدعم القلب. تشمل النتائج طويلة الأمد:",
            "items": [
                {
                    "title": "زيادة القدرة على التحمل وانخفاض الشعور بالإرهاق",
                    "desc": "",
                    "icon": "fa-solid fa-battery-full"
                },
                {
                    "title": "تحسين تدفق الدم وتنشيط الدورة الدموية",
                    "desc": "",
                    "icon": "fa-solid fa-heart-pulse"
                },
                {
                    "title": "تقليل خطر التعرض لمشكلات قلبية",
                    "desc": "",
                    "icon": "fa-solid fa-heart-circle-check"
                },
                {
                    "title": "دعم أفضل لوظائف الجهاز المناعي",
                    "desc": "",
                    "icon": "fa-solid fa-shield-virus"
                }
            ]
        },
        "aftercareTips": {
            "heading": "إرشادات العناية بعد الجلسة",
            "subheading": "",
            "para": "لا حاجة لتغييرات كبيرة بعد العلاج؛ يمكنك استئناف أنشطتك اليومية مباشرةً. يُفضل الحفاظ على ترطيب الجسم والانتباه لأي أعراض غير معتادة، على الرغم من أن الآثار الجانبية نادرة.",
            "items": [
                {
                    "title": "الترطيب",
                    "desc": "استمر في شرب كميات كافية من الماء بعد العلاج.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "مراقبة جسمك",
                    "desc": "انتبه لكيفية استجابة جسمك للعلاج.",
                    "icon": "fa-solid fa-heartbeat"
                },
                {
                    "title": "جلسات المتابعة",
                    "desc": "فكر في الجلسات المنتظمة للحصول على دعم مستمر لصحة القلب.",
                    "icon": "fa-solid fa-calendar-alt"
                },
                {
                    "title": "نمط حياة صحي",
                    "desc": "حافظ على عادات صحية للقلب لتعزيز تأثيرات العلاج.",
                    "icon": "fa-solid fa-heart"
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "",
            "items": [
                {
                    "question": "كم تستغرق جلسة دعم القلب بالتنقيط الوريدي؟",
                    "answer": "تستغرق جلسة الحقن الوريدي من 30 إلى 60 دقيقة تقريبًا."
                },
                {
                    "question": "هل العلاج مؤلم؟",
                    "answer": "قد يشعر المرضى بوخز بسيط عند إدخال الإبرة، لكن العلاج نفسه غير مؤلم."
                },
                {
                    "question": "متى سألاحظ النتائج؟",
                    "answer": "يذكر العديد من المرضى شعورًا بتحسن مستويات الطاقة ووظائف القلب خلال الجلسات الأولى."
                },
                {
                    "question": "كم مرة يجب أن أحصل على هذا العلاج؟",
                    "answer": "يعتمد التكرار على الاحتياجات الفردية - يمكن لأطبائنا تقديم توصية أثناء الاستشارة."
                },
                {
                    "question": "هل هناك أي آثار جانبية؟",
                    "answer": "الآثار الجانبية نادرة ولكن قد تشمل كدمات طفيفة في موقع الحقن."
                }
            ]
        }
    }
}